import { render, staticRenderFns } from "./EditReturn.vue?vue&type=template&id=971a9628&"
import script from "./EditReturn.vue?vue&type=script&lang=js&"
export * from "./EditReturn.vue?vue&type=script&lang=js&"
import style0 from "./EditReturn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditReturn.vue"
export default component.exports